module.exports = __webpack_public_path__ + "static/aer2-202db49a3a080a080002b85b7cd11117.png";